import { useEffect, useState } from "react";
import MainPanel from "../../components/MainPanel/MainPanel";
import DefaultLayout from "../../layout/Layout";
import OrderHeader from "./Header";
import { DataGrid } from "@mui/x-data-grid";
import { Forward } from "@mui/icons-material";
import OrderDetail from "./OrderDetail";
import { useSelector } from "react-redux";

const Order = () => {
  const columns = [
    { field: "order_id", headerName: "Order ID", width: 120, sortable: false },
    {
      field: "event_name",
      headerName: "Event Name",
      width: 200,
      sortable: false,
    },
    { field: "venue_name", headerName: "Venue", width: 250, sortable: false },
    {
      field: "marketplace",
      headerName: "Marketplace",
      width: 120,
      sortable: false,
    },
    { field: "section", headerName: "Section", width: 70, sortable: false },
    { field: "row", headerName: "Row", width: 70, sortable: false },
    { field: "quantity", headerName: "Qty", width: 50, sortable: false },
    {
      field: "unit_price",
      headerName: "Unit Price/Total",
      width: 120,
      renderCell: (param) => {
        const { unit_price, total } = param.row;
        return `${unit_price}/${total}`;
      },
      sortable: false,
    },
    {
      field: "occurs_at",
      headerName: "Occurs at",
      width: 200,
      renderCell: (param) => {
        return new Date(param.value).toLocaleString();
      },
    },
    {
      field: "order_date",
      headerName: "Order Date",
      width: 200,
      renderCell: (param) => {
        return new Date(param.value).toLocaleString();
      },
    },
    {
      field: "pos_event_id",
      headerName: "POS Event ID",
      width: 120,
      sortable: false,
    },
    {
      field: "pos_inventory_id",
      headerName: "Inventory ID",
      width: 120,
      sortable: false,
    },
    {
      field: "deliver_urls",
      headerName: "Delivery URL",
      width: 120,
      sortable: false,
      renderCell: (param) => {
        if (param.value && param.value.length) {
          return (
            <a
              href={param.value[0]}
              target="_blank"
              className="border border-bodydark px-2 py-1 rounded"
              rel="noreferrer noopener"
            >
              Open
            </a>
          );
        }
        return "Unknown";
      },
    },
    { field: "status", headerName: "Status", width: 120, sortable: false },
    {
      field: "option",
      headerName: "",
      width: 50,
      sortable: false,
      renderCell: (param) => {
        return (
          <Forward
            className="text-white cursor-pointer"
            onClick={() => setOrderDetail(param.row)}
          />
        );
      },
      disableColumnMenu: true,
      disableColumnResize: true,
    },
    // Add more columns as needed
  ];

  const [totalRows, setTotalRows] = useState(0);
  const [orders, setOrders] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });

  const [orderDetail, setOrderDetail] = useState(null);

  const ordersData = useSelector((state) => state.orders);
  useEffect(() => {
    if (ordersData) {
      const { count, orders } = ordersData.orders;
      setTotalRows(count || 0);
      setOrders(orders);
    }
  });

  const onChange = (e) => {
    setPaginationModel(e);
  };
  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>
        {orderDetail ? (
          <OrderDetail data={orderDetail} goBack={() => setOrderDetail(null)} />
        ) : (
          <div className="flex flex-col h-full">
            <OrderHeader paginationModel={paginationModel} />
            <div
              style={{ height: "calc(100vh - 200px)", width: "100%" }}
              className="mt-4"
            >
              <DataGrid
                rows={orders}
                columns={columns}
                pagination
                rowCount={totalRows}
                rowBufferPx={100}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={onChange}
                classes={{
                  root: "bg-boxdark border-boxdark-2",
                }}
                sx={{
                  color: "white",
                  "& .*-MuiDataGrid-columnHeaderRow": {
                    background: "red",
                  },
                }}
                checkboxSelection
              />
            </div>
          </div>
        )}
      </MainPanel>
    </DefaultLayout>
  );
};
export default Order;
